// import constants from './constants';

export default {
};



// WEBPACK FOOTER //
// ./src/store/modules/setting/getters.js